import React from 'react';
import Typography from '@mui/material/Typography';

export function SectionTitle({ children, light, component, sx: sxProp }) {
    return (
        <Typography
            variant="h2"
            component={component}
            sx={{
                fontSize: { xs: '1.8rem', md: '2.4rem' },
                lineHeight: 1.2,
                letterSpacing: '-0.03em',
                ...(light && { color: 'white' }),
                mb: 1.5,
                ...sxProp,
            }}
        >
            {children}
        </Typography>
    );
}
